// extracted by mini-css-extract-plugin
export default {"socialIconsContainer":"SocialLinks_socialIconsContainer__j1Uza","socialIcon":"SocialLinks_socialIcon__mQC7W","socialIconInsideFloat":"SocialLinks_socialIconInsideFloat__XBJP+"};